import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=e34dfa9c&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=tsx&"
export * from "./Error404.vue?vue&type=script&lang=tsx&"
import style0 from "./Error404.vue?vue&type=style&index=0&id=e34dfa9c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34dfa9c",
  null
  
)

export default component.exports